import api from '../../services/api';

export default {
	getOverview(params = {}) {
		return api.get('/dashboard', { params });
	},
};